import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LearnerTable from './learnerTable';

const LearnerStatuses = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  useEffect(() => {
    if (user?.permissions?.learner_statuses?.add_edit) {
      setCanUpdate(true);
    }
    if (user?.permissions?.learner_statuses?.delete) {
      setCanDelete(true);
    }
  }, [user]);

  return (
    <div className='page-top-div'>
      <span className='text-span'>Learner Statuses Manager</span>
      <LearnerTable canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default LearnerStatuses;
